import { HttpMethod } from '@/constants/utils'
import { PRODUCT } from '@/utils'
import { createBillingApiRequest } from '@/utils/api'
import { IRecurrentChargeRequest } from './interfaces'

const read = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.GET,
    path: `/recurrent_charge/${productType}/${id}`,
  })

const readAll = (
  order_client_id: string,
  status = '',
  productType = PRODUCT.LiveChat
) =>
  createBillingApiRequest({
    method: HttpMethod.GET,
    path: `/recurrent_charge/${productType}?order_client_id=${order_client_id}&status=${status}`,
  })

const create = ({
  name,
  price,
  return_url,
  trial_days,
  per_account,
  clientId,
  months = 1,
  test = false,
  product = PRODUCT.LiveChat,
}: IRecurrentChargeRequest) => {
  return createBillingApiRequest({
    method: HttpMethod.POST,
    path: `/recurrent_charge/${product}`,
    body: {
      name,
      price,
      return_url,
      order_client_id: clientId,
      trial_days,
      per_account,
      months,
      test,
    },
  })
}

const activate = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/recurrent_charge/${productType}/${id}/activate`,
  })

const cancel = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/recurrent_charge/${productType}/${id}/cancel`,
  })

const decline = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/recurrent_charge/${productType}/${id}/decline`,
  })

const accept = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/recurrent_charge/${productType}/${id}/accept`,
  })

export default {
  read,
  readAll,
  activate,
  cancel,
  create,
  decline,
  accept,
}
